import { useMantineTheme } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"

import { mobileBreakpoint } from "app/static/frontend/design-constants"

/**
 * Utility hook to quickly query the general size of the user's window. If you find yourself regularly checking for
 * isMobile, isTablet, etc, add your breakpoint here, and call it like so
 *
 * @example const { isMobile } = useResponsiveSize()
 */
export const useResponsiveSize = (): { [key: string]: boolean } => {
    const theme = useMantineTheme()
    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`, window.innerWidth <= mobileBreakpoint)
    const isTablet = useMediaQuery(`(${theme.breakpoints.xs} < width <= ${theme.breakpoints.md})`)
    const isMedium = useMediaQuery(`(${theme.breakpoints.md} < width <= ${theme.breakpoints.lg}`)
    const isLarge = useMediaQuery(`width > ${theme.breakpoints.lg}`)

    return { isMobile, isTablet, isMedium, isLarge }
}
